import { AfterViewInit, Component, OnInit } from '@angular/core'
import { BehaviorSubject, Subscription } from 'rxjs'
import { AuthenticationService } from '../../access/shared/authentication/authentication.service'
import { NotificationService } from '../../notification/shared/notification.service'
import { OfflineService } from '../../shared/offline.service'
import { ClientService } from '../shared/client/client.service'
import { LoaderService } from './shared/loader/loader.service'

@Component({
  selector: 'app-tool-bar',
  templateUrl: './tool-bar.component.html',
  styleUrls: ['./tool-bar.component.scss']
})
export class ToolBarComponent implements OnInit, AfterViewInit {

  subClient: Subscription
  public mode: BehaviorSubject<string> = new BehaviorSubject<string>("indeterminate")

  isOnline: boolean = true
  appEnv = null
  currentClient = null
  currentUser = null

  constructor(
    private loadingService: LoaderService,
    private offlineService: OfflineService,
    private notificationService: NotificationService,
    private clientService: ClientService,
    private authenticationService: AuthenticationService
  ) {
    this.offlineService.isOnline().subscribe(res => this.isOnline = res)
  }

  ngAfterViewInit() {
    this.loadingService.loadingProgress.subscribe(loadingPogress => {
      this.progress(loadingPogress)
    })
  }


  ngOnInit() {
    this.notificationService.getAppEnv().subscribe(result => {
      if (result != 'prod') {
        this.appEnv = result
      }
    })

    if (!this.authenticationService.currentUser$.getValue().roles.includes('ROLE_ANETT')) {
      this.subClient = this.clientService.getCurrentClient().subscribe(client => {
        if (this.currentUser != this.authenticationService.currentUser$.getValue() && this.currentClient != client) {
          this.currentUser = this.authenticationService.currentUser$.getValue()
          this.currentClient = client

          this.clientService.postLastAccess(this.currentClient.id, this.currentUser).subscribe()
        }
      })
    }
  }

  ngOnDestroy() {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  private progress(loadingPogress: number) {
    if (loadingPogress != 100) {
      this.mode.next("indeterminate")
    } else {
      this.mode.next("determinate")
    }
  }
}
